import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import media from 'src/styles/media';

import imgArrowRight from 'src/assets/images/button-arrow-right.png';

const CircularImage = props => {
  const {
    top,
    bottom,
    left,
    right,
    to,
    image,
    rotate,
    hidecircle,
    innerheader,
    innertext,
    outerheader,
    outertext,
  } = props;
  const Root = to ? RootLink : RootDiv;
  return (
    <Root
      {...props}
      top={top}
      bottom={bottom}
      left={left}
      right={right}
      to={to}
    >
      <Background image={image} rotate={rotate} hidecircle={hidecircle}>
        {innerheader && <h3>{innerheader}</h3>}
        {innertext && <p>{innertext}</p>}
        {innerheader && <img src={imgArrowRight} alt="Arrow Right" />}
      </Background>
      {outerheader && <h3>{outerheader}</h3>}
      {outertext && <p>{outertext}</p>}
      {outerheader && <img src={imgArrowRight} alt="Arrow Right" />}
    </Root>
  );
};

export default CircularImage;

CircularImage.propTypes = {
  to: PropTypes.string,
  image: PropTypes.string,
  outerheader: PropTypes.string,
  outertext: PropTypes.string,
  innerheader: PropTypes.string,
  innertext: PropTypes.string,
  rotate: PropTypes.number,
  top: PropTypes.string,
  bottom: PropTypes.string,
  left: PropTypes.string,
  right: PropTypes.string,
  hidecircle: PropTypes.string,
};

CircularImage.defaultProps = {
  to: '',
  hidecircle: '',
};

const styledRoot = css`
  text-align: center;
  z-index: 10;
  @media (min-width: ${media.smup}) {
    position: ${props => (props.top || props.bottom ? 'absolute' : 'relative')};
    top: ${props => props.top};
    bottom: ${props => props.bottom};
    left: ${props => props.left};
    right: ${props => props.right};
  }
  h3 {
    text-transform: uppercase;
    color: black;
    margin: 10px 0;
    font-family: ${({ theme }) => theme.fontHeader};
  }
  p {
    color: black;
    font-family: ${({ theme }) => theme.fontMain};
    opacity: 0.72;
  }
`;

const RootLink = styled(Link)`
  ${styledRoot};
`;

const RootDiv = styled.div`
  ${styledRoot};
`;

const Background = styled.div`
  background-image: url(${props => props.image});
  margin: 0 auto;
  width: 245px;
  height: 260px;
  background-size: cover;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  @media (min-width: ${media.smup}) {
    margin: 0;
  }
  &::after {
    content: '';
    position: absolute;
    width: 245px;
    height: 245px;
    border-radius: 50%;
    border: 10px solid ${({ theme }) => theme.colorPrimary};
    border-bottom-color: transparent;
    border-right-color: transparent;
    transform: ${props => `rotate(${props.rotate}deg)`};
    display: ${props => props.hidecircle && 'none'};
    transition: all 0.8s ease-out;
  }

  &:hover {
    &::after {
      transform: ${props => `rotate(${props.rotate + 180}deg)`};
    }
  }

  h3,
  p {
    color: white;
    opacity: 1;
  }

  img {
    position: absolute;
    bottom: -4vw;
    z-index: 10;
    @media (min-width: ${media.smup}) {
      bottom: -1.5vw;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/CircularImage.js